export default __webpack_public_path__ + "static/media/friends.6cbc35ef.jpg";